import { all } from "redux-saga/effects";
import { AuthSaga } from "./auth/AuthSaga";
import { BarClubSaga } from "./barclub/BarClubSaga";
import { CustomerSaga } from "./customer/CustomerSaga";
import { ProductSaga } from "./products/ProductSaga";
import { WholesalerSaga } from "./wholesaler/WholesalerSaga";
import { BrandSaga } from "./brands/BrandSaga";
import { ProductQuantitySaga } from "./productQuantity/ProductQuantitySaga";
import { WholesalerProductSaga } from "./wholesalerProduct/WholesalerProductSaga";
import { TypeOfAlcoholSaga } from "./typeOfAlcohol/TypeOfAlcoholSaga";
import { ConsumptionSaga } from "./reports/ReportSaga";
import { CustomerAddressSaga } from "./customerAddress/customerAddressSaga";
import { CustomerReportSaga } from "./customerReport/CustomerReportSaga";
import { BarReportSaga } from "./barReport/BarReportSaga";
import { WholesalerReportByIdSaga } from "./wholesalerReportById/WholesalerReportByIdSaga";

export default function* rootSaga() {
  yield all([
    AuthSaga(),
    ProductSaga(),
    WholesalerSaga(),
    BarClubSaga(),
    CustomerSaga(),
    BrandSaga(),
    ProductQuantitySaga(),
    WholesalerProductSaga(),
    TypeOfAlcoholSaga(),
    ConsumptionSaga(),
    CustomerAddressSaga(),
    CustomerReportSaga(),
    BarReportSaga(),
    WholesalerReportByIdSaga(),
  ]);
}
